import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot} from '@angular/router';
import {AuthService} from '../services/auth.service'; // Adjust the path as necessary

@Injectable({
  providedIn: 'root'
})
export class AuthenticateGuard {
  constructor(private authService: AuthService, private router: Router) {
  }

  canActivate: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    if (this.authService.tokenValid()) {
      return true;
    } else {
      this.router.navigate(['/login']);
    }

    return false;
  };
}
